import React, { useEffect, useState } from 'react'
import { ContainerDependencies, TextHeader } from './dependencies.style'
import WaitingOnCommon from 'common/Dependencies/waitingOn'
import BockingCommon from 'common/Dependencies/bocking'
import TasksCommon from 'common/Dependencies/tasks'
import {
  addDependencies,
  deleteDependencies,
  getDependenciesList,
  searchDependencies,
} from 'api/Project/dependencies'
import { getCookie } from 'helper/cookie'
import { notification } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import Swal from 'sweetalert2'

const Dependencies = (props) => {
  const { sprintflowId, projectId, taskStatus } = props
  const token = getCookie('access_token_admin')
  const [dataSelect, setDataSelect] = useState([])
  const [dataTaskWaitingOn, setDataTaskWaitingOn] = useState([])
  const [dataTaskBocking, setDataTaskBocking] = useState([])
  const [dataTaskTasks, setDataTaskTasks] = useState([])
  const [api, contextHolder] = notification.useNotification()
  const [form] = useForm()

  useEffect(() => {
    getApiDependenciesList()
  }, [])

  const getApiDependenciesList = async () => {
    await getDependenciesList(projectId, sprintflowId, token).then((res) => {
      const { data, status } = res
      if (status === 200) {
        setDataTaskWaitingOn(data.waiting_on || []),
          setDataTaskBocking(data.blocking || []),
          setDataTaskTasks(data.tasks || [])
      }
    })
  }

  const sendSearchDependencies = async () => {
    const prarams = {
      project_id: String(projectId),
      sprintflow_id: String(sprintflowId),
      search: '',
    }
    await searchDependencies(prarams, token).then((res) => {
      const { data, status } = res
      if (status === 200) {
        setDataSelect(data || [])
      } else {
        setDataSelect([])
      }
    })
  }

  const onChangeDataTaskInSelectByDepen = async (option, type) => {
    let prarams = {}
    if (type === 'waiting_on') {
      prarams = {
        project_id: Number(projectId),
        sprintflow_id: Number(sprintflowId),
        waiting_on: Number(option?.value),
        blocking: 0,
        tasks: 0,
      }
    } else if (type === 'bocking') {
      prarams = {
        project_id: Number(projectId),
        sprintflow_id: Number(sprintflowId),
        waiting_on: 0,
        blocking: Number(option?.value),
        tasks: 0,
      }
    } else if (type === 'tasks') {
      prarams = {
        project_id: Number(projectId),
        sprintflow_id: Number(sprintflowId),
        waiting_on: 0,
        blocking: 0,
        tasks: Number(option?.value),
      }
    }

    await addDependencies(prarams, token).then(async (res) => {
      const { status } = res
      if (status === 200) {
        api.success({
          message: (
            <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#07a721' }}>
              Successfully
            </p>
          ),
          description: 'Your dependencies has been saved.',
          className: 'custom-notification',
        }),
          await getApiDependenciesList(),
          await sendSearchDependencies(),
          form.resetFields()
      }
    })
  }

  const onDeleteTaskByDepen = async (item, type) => {
    let prarams = {}

    if (type === 'waiting_on') {
      prarams = {
        project_id: Number(projectId),
        sprintflow_id: Number(sprintflowId),
        waiting_on: item?.sprintflow_id, // รหัสที่จะลบ
        blocking: 0,
        tasks: 0,
      }
    } else if (type === 'bocking') {
      prarams = {
        project_id: Number(projectId),
        sprintflow_id: Number(sprintflowId),
        waiting_on: 0,
        blocking: item?.sprintflow_id, // รหัสที่จะลบ
        tasks: 0,
      }
    } else if (type === 'tasks') {
      prarams = {
        project_id: Number(projectId),
        sprintflow_id: Number(sprintflowId),
        waiting_on: 0, // รหัสที่จะลบ
        blocking: 0,
        tasks: item?.sprintflow_id,
      }
    }

    const res = await Swal.fire({
      title: `Delete "${item?.title}"`,
      html: `Are you sure you want to delete “${item?.title}”?`,
      icon: 'error',
      showConfirmButton: true,
      timer: false,
      showCancelButton: true,
      showCloseButton: true,
      reverseButtons: true,
      confirmButtonText: 'Delete',
      showClass: {
        popup: 'animate__animated animate__fadeInDown',
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp',
      },
    })
    const { isConfirmed } = res
    if (isConfirmed) {
      await deleteDependencies(prarams, token).then(async (res) => {
        const { status } = res
        if (status === 200) {
          await getApiDependenciesList(), await sendSearchDependencies()
        }
      })
    }
  }

  return (
    <ContainerDependencies>
      {contextHolder}
      <TextHeader>
        <p>Dependencies</p>
      </TextHeader>

      <WaitingOnCommon
        dataSelect={dataSelect}
        dataTasks={dataTaskWaitingOn}
        typeTask={'task'}
        sendSearchDependencies={sendSearchDependencies}
        onChangeInSelect={onChangeDataTaskInSelectByDepen}
        form={form}
        onDeleteTaskByDepen={onDeleteTaskByDepen}
        taskStatus={taskStatus}
      />
      <BockingCommon
        dataSelect={dataSelect}
        dataTasks={dataTaskBocking}
        typeTask={'task'}
        sendSearchDependencies={sendSearchDependencies}
        onChangeInSelect={onChangeDataTaskInSelectByDepen}
        form={form}
        onDeleteTaskByDepen={onDeleteTaskByDepen}
        taskStatus={taskStatus}
      />
      <TasksCommon
        dataSelect={dataSelect}
        dataTasks={dataTaskTasks}
        typeTask={'task'}
        sendSearchDependencies={sendSearchDependencies}
        onChangeInSelect={onChangeDataTaskInSelectByDepen}
        form={form}
        onDeleteTaskByDepen={onDeleteTaskByDepen}
        taskStatus={taskStatus}
      />
    </ContainerDependencies>
  )
}

export default Dependencies
